export var SELECT_COLUMN_ID = 'selection';
